import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Page } from "src/app/util/page";
import { PurchaseOrder } from "../order/purchase-order";
import { Invoice } from "./invoice";
import { InvoiceSearchResult } from "./invoice-search-result";
import { SearchRequest } from "./search-request";

@Injectable()
export class InvoiceService {
  constructor(private httpClient: HttpClient) {

  }

  public findById(id: string): Observable<Invoice> {
    return this.httpClient.get<Invoice>("/api/purchase/invoice/" + id);
  }

  public findBySupplierIdAndSupplierInvoiceNumber(supplierId: string, supplierInvoiceNumber: string): Observable<Invoice> {
    return this.httpClient.get<Invoice>(`/api/purchase/invoice?supplierId=${supplierId}&supplierInvoiceNumber=${supplierInvoiceNumber}`);
  }

  public findNeedaFiles(invoice: string): Observable<string[]> {
    return this.httpClient.get<string[]>("/api/purchase/invoice/" + invoice + "/needa");
  }

  public findPurchaseOrders(id: string): Observable<PurchaseOrder[]> {
    return this.httpClient.get<PurchaseOrder[]>("/api/purchase/invoice/" + id + "/purchase-orders")
  }

  public search(searchRequest: SearchRequest, page: number, size: number): Observable<Page<InvoiceSearchResult>> {
    return this.httpClient.post<Page<InvoiceSearchResult>>(
      "/api/purchase/invoice?search&page=" + page + "&size=" + size + "&sort=creationTimestamp,DESC",
      searchRequest,
    );
  }
}